<div>
    <ngx-loading-bar 
        color="#f76617" 
        diameter="15px"
    ></ngx-loading-bar>
   
    <router-outlet></router-outlet>
    <app-footer ></app-footer>
</div>